import React from "react";

const LangContext = React.createContext({ lang: "" });

export default LangContext;
